import { isArray } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { stringFormat, trim } from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { ChangeEvent, useContext, useRef } from 'react';
import { useEffectCustom } from '../../../hooks';
import { FormContext } from '../../context';
import { omit } from '../../helps/utils';
import './style.less';
import { InputProps, InputPropsInner } from './type';

/**
 * input组件的 value、defaultValue 属性，不提供给Form外部使用
 * 如果需要设置value和defaultValue属性，请使用form方法设置
 * @param props
 * @returns
 */
export const Input = (props: InputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const newProps = props as unknown as InputPropsInner;
  const { form } = useContext(FormContext);
  const fieldValue = form.getFieldValue(newProps.name);
  const cpLockRef = useRef(false);

  const onInputChange = hooks.useCallbackRef((event: ChangeEvent) => {
    if (!cpLockRef.current) {
      const value = event.target['value'] as string;
      if (isArray(newProps.format) && newProps.format.length > 0) {
        newProps.onChange(trim(value), event);
      } else {
        newProps.onChange(value, event);
      }
    }
  });

  useEffectCustom(() => {
    if (inputRef.current) {
      const value = String(fieldValue || '');
      if (typeof newProps.format === 'function') {
        inputRef.current.value = newProps.format(value);
      } else if (isArray(newProps.format) && newProps.format.length > 0) {
        inputRef.current.value = stringFormat(value, newProps.format).join(' ');
      } else {
        inputRef.current.value = value;
      }
    }
  }, [fieldValue]);

  const compositionstartHandle = hooks.useCallbackRef(() => {
    cpLockRef.current = true;
  });

  const compositionendHandle = hooks.useCallbackRef((event) => {
    cpLockRef.current = false;
    onInputChange(event as ChangeEvent);
  });

  useEffectCustom(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('compositionstart', compositionstartHandle);
      inputRef.current.addEventListener('compositionend', compositionendHandle);
    }
  }, []);

  const convertProps = omit(newProps, ['value', 'suffix', 'format']);

  return (
    <input
      {...convertProps}
      className={classNames('v-input', newProps.className)}
      onChange={onInputChange}
      ref={inputRef}
    />
  );
};

Input.domTypeName = 'Input';
